import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import ContentFormSquelette from "../layouts/ContentFormSquelette";
import Form from "../components/Form";
import InputPassword from "../components/InputPassword";
import InputText from "../components/InputText";
import Spinner from "../components/Spinner";
import { AuthContext } from "../contexts/AuthContext";
import { env } from "../datas.config";
import PasswordRequirements from "../components/PasswordRequirements";

export default function SigninPage() {
  const { setUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [visibility, setVisibility] = useState(false);
  const connexion = (evt, login, password) => {
    evt.preventDefault();
    setVisibility(true);
    fetch(`${env.domain}/api/visitor/signin`, {
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "post",
      body: JSON.stringify({
        login,
        password,
      }),
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.status !== 200) {
          setMessage(data.msg || "Une erreur est survenue.");
        } else {
          setUser(data.userData);
          navigate("/");
        }
        setTimeout(() => setVisibility(false), 200);
      });
  };
  return (
    <ContentFormSquelette>
      {visibility ? (
        <Spinner visibility={visibility} />
      ) : (
        <>
          <form onSubmit={(evt) => connexion(evt, login, password)}>
            <Form
              faire="Se connecter"
              colClasses="col-xl-4 col-lg-5 col-md-7 col-sm-9 animate__animated animate__backInUp"
              hideLogo
            >
              <div className="row g-3">
                <InputText
                  label="Nom d'utilisateur ou login"
                  placeholder="Nom d'utilisateur ou login"
                  col="col-12"
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                />
                <InputPassword
                  label="Mot de passe"
                  placeholder="Mot de passe"
                  col="col-12"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div className="col-12">
                  <PasswordRequirements password={password} />
                </div>
                {message && (
                  <small className="text-danger">{message}</small>
                )}
                <div className="col-12">
                  <button
                    className="btn btn-primary w-100"
                    disabled={password === "" || login === ""}
                  >
                    Se connecter
                  </button>
                </div>
                <Link className="text-center" to="/password-forgot">
                  Mot de passe oublié?
                </Link>
              </div>
            </Form>
          </form>
          <div className="text-center mt-4 animate__animated animate__delay-1s animate__bounceInLeft">
            <Link to="/signup">
              Vous n'avez pas de compte?{" "}
              <span className="text-primary">En créer</span>
            </Link>
          </div>
        </>
      )}
    </ContentFormSquelette>
  );
}
